import SpecificCard from './SpecificCard';

export default SpecificCard;
